import React from 'react';
import { Button } from 'react-bootstrap';
import { useSynchTripReport } from './hooks';

interface Props {
  synchTripId: number;
  closeReportOptionsModal?: () => void;
  expId?: number;
}

const SynchTripReportOptions = (props: Props) => {
  const { synchTripId, closeReportOptionsModal } = props;
  const {
    reportOptions,
    openSynchTripReport,
    saveSynchTripReport,
    toggleSynchTripInfoReport,
    toggleSynchTripResultReport,
  } = useSynchTripReport(synchTripId);

  const handleOpenSynchTripReport = async () => {
    openSynchTripReport([synchTripId]);
    closeReportOptionsModal();
  };

  const handleSaveSynchTripReport = async () => {
    saveSynchTripReport([synchTripId]);
    closeReportOptionsModal();
  };

  return (
    <div id="synchrotron-synchtripreportoptions-wrapper" className="text-md">
      <div
        id="synchrotron-synchtripreportoptions-warning-message"
        className="w-[35rem] mb-3"
      >
        Please provide information you want to include into the report.
      </div>
      <div
        id="synchrotron-synchtripreportoptions-tripinformation-wrapper"
        className="flex flex-row items-center"
      >
        <input
          type="checkbox"
          id="synchrotron-synchtripreportoptions-tripinformation-input"
          className="h-4 w-4 rounded"
          checked={reportOptions.tripInfoReport}
          onChange={toggleSynchTripInfoReport}
        />
        <label
          id="synchrotron-synchtripreportoptions-tripinformation-label"
          htmlFor="tripinfo"
          className="m-1"
        >
          Synchrotron Trip Information
        </label>
      </div>
      <div
        id="synchrotron-synchtripreportoptions-result-wrapper"
        className="flex flex-row items-center"
      >
        <input
          type="checkbox"
          id="synchrotron-synchtripreportoptions-result-input"
          className="h-4 w-4 rounded"
          checked={reportOptions.tripResultReport}
          onChange={toggleSynchTripResultReport}
          disabled={!reportOptions.tripInfoReport}
        />
        <label
          id="synchrotron-synchtripreportoptions-result-label"
          htmlFor="tripresult"
          className="m-1"
        >
          Synchrotron Result
        </label>
      </div>
      <div
        id="synchrotron-synchtripreportoptions-button-lists"
        className="flex w-full justify-end my-2"
      >
        <Button
          id="synchrotron-synchtripreportoptions-preview-button"
          variant="light"
          onClick={handleOpenSynchTripReport}
          disabled={!reportOptions.tripInfoReport}
        >
          Preview
        </Button>
        <Button
          id="synchrotron-synchtripreportoptions-save-button"
          variant="primary"
          onClick={handleSaveSynchTripReport}
          className="ml-2"
          disabled={!reportOptions.tripInfoReport}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SynchTripReportOptions;
